import { IPartsSpecialist } from '@module/analysis/RequestLogFilter/RequestLogFilter';
import { IUserToken } from '@module/authentication/models';

export async function FetchPartsSpecialists(loggedInUser: IUserToken) {
    const url = `${environmentSettings.webapiUrl}/v1/Request/PartsSpecialists`;
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + loggedInUser.access_token);
    headers.append('pragma', 'no-cache');
    headers.append('cache-control', 'no-cache');
    const response = await fetch(url, { headers, cache: 'no-store' });
    if (response.ok) {
      const partsSpecialists: IPartsSpecialist[] = await response.json();
      return partsSpecialists;
    } else {
      return Promise.reject(`System error: ${response.status} ${response.statusText}`);
    }
  }
  
  // tslint:disable-next-line:eofline
  